export default "__VITE_ASSET__Ua8qSbtk__"